import React, {useState} from "react";

import {i18n} from "translate/i18n";

import { useParams} from "react-router";
import {useUser} from "store/providers/app";
import Page from "components/Page";
import FormResponsible from "./Form/form-responsible";
import FormTable from "./Form/form-table"
import FormCollect from "./Form/form";
import Steps from "../../components/Steps";
import LogsIndicator from "./logs";
import PreviewIndicator from "./preview";
import {Tooltip} from "../../components/Tooltip";
import {toast} from "react-toastify";
import FormTranslate from "./Form/form-translate";

export default function TabsFormCollect() {

    let {id} = useParams();
    const {user} = useUser();
    const [update, setUpdate] = useState(new Date())

    const updatePreview = () => {
        setUpdate(new Date())
        toast.success('As informações foram atualizadas!');
    }

    return (
        <Page
            label="Formulário de Coleta"
            icon="bi bi-pencil-square"
            loading={false}
        >

            <ul className="nav nav-tabs mt-4 border-bottom-0" id="myTab" role="tablist">

                <li className="nav-item mt-2" role="presentation">
                    <button className="nav-link border-0 shadow-sm active" id="indicator-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#indicator" type="button" role="tab" aria-controls="indicator"
                            aria-selected="true">{i18n.t('titlePage.indicator')}
                    </button>
                </li>

                { id && user.profile === 1 &&
                    <li className="nav-item mt-2" role="presentation">
                        <button className="nav-link border-0 shadow-sm" id="resposible-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#resposible" type="button" role="tab" aria-controls="resposible"
                                aria-selected="true">Responsável
                        </button>
                    </li>
                }

                { id &&
                    <li className="nav-item mt-2" role="presentation">
                        <button className="nav-link border-0 shadow-sm" id="table-tab"
                                data-bs-toggle="offcanvas" data-bs-target="#offcanvasTop"
                                aria-controls="offcanvasTop">Tabelas
                        </button>
                    </li>
                }

                <li className="nav-item mt-2" role="presentation">
                    <button className="nav-link border-0 shadow-sm" id="preview-tab"
                            data-bs-toggle="offcanvas" data-bs-target="#offcanvasPreview"
                            aria-controls="offcanvasPreview">Visualizar
                    </button>
                </li>

                {id && user.profile === 1 &&
                    <li className="nav-item mt-2" role="presentation">
                        <button className="nav-link border-0 shadow-sm" id="logs-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#logs" type="button" role="tab" aria-controls="logs"
                                aria-selected="true">Logs
                        </button>
                    </li>
                }

            </ul>

            <div className="card rounded-0 rounded-bottom border-0 shadow-sm">
                <div className="card-body p-0">
                    <div className="tab-content" id="myTabContent">

                        <div className="tab-pane fade show active p-0" id="indicator" role="tabpanel"
                             aria-labelledby="indicator-tab">
                            <FormCollect />
                        </div>

                        { id && user.profile === 1 &&
                            <div className="tab-pane fade p-0" id="resposible" role="tabpanel"
                                 aria-labelledby="resposible-tab">
                                <FormResponsible />
                            </div>
                        }

                        { id && user.profile === 1 &&
                            <div className="tab-pane fade" id="logs" role="tabpanel"
                                 aria-labelledby="logs-tab">
                                <LogsIndicator />
                            </div>
                        }

                    </div>
                </div>
            </div>

            { id &&
                <div className="offcanvas offcanvas-top h-100" tabIndex="-1" id="offcanvasTop"
                     aria-labelledby="offCanvasCharts">
                    <div className="offcanvas-header bg-primary">
                        <h5 id="offCanvasCharts"
                            className="text-uppercase mt-1">Tabelas</h5>
                        <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas"
                                aria-label="Close"/>
                    </div>
                    <div className="offcanvas-body">
                         <FormTable/>
                    </div>
                </div>
            }

            <div className="offcanvas offcanvas-top h-100" tabIndex="-1" id="offcanvasPreview"
                 aria-labelledby="offCanvasPreview">
                <div className="offcanvas-header bg-primary">
                    <h5 id="offCanvasPreview" className="text-uppercase mt-1">Visualizaçao</h5>
                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas"
                            aria-label="Close"/>
                </div>
                <div className="offcanvas-body p-0">
                    <Tooltip label="Atualizar informações">
                        <button type="button" onClick={() => updatePreview()} className="btn btn btn-success btn-reload">
                            <i className="bi bi-arrow-repeat"/>
                        </button>
                    </Tooltip>
                    <PreviewIndicator update={update} />
                </div>
            </div>

        </Page>
    )
}
